import React from "react";
import { useTranslation } from "react-i18next";
import { Calendar, ChevronLeft, ChevronRight } from "lucide-react";
import { parseYmd, ymd } from "../../../api/recolecciones";
import { formatLargo } from "./recoleccionesShared";

/**
 * DayBar — navegador de día compacto para las pestañas Monitoreo y Retiros.
 * Comparte `selectedDate` (URL) con Planificación, que conserva su propio
 * navegador con la franja semanal. `extra` inyecta acciones a la derecha
 * (p. ej. el botón "Descargar CSV" de la pestaña Retiros).
 */
export function DayBar({ selectedDate, onSelectedDateChange, todayYmd, extra }) {
  const { t } = useTranslation();
  const isToday = selectedDate === todayYmd;
  const navDay = (delta) => {
    const d = parseYmd(selectedDate);
    d.setDate(d.getDate() + delta);
    onSelectedDateChange(ymd(d));
  };
  return (
    <div className="rec-card rec-card--flush">
      <div className="rec-daynav rec-daynav--solo">
        <div className="rec-daynav__current">
          <Calendar size={16} className="rec-ico-brand" />
          <span className="rec-daynav__label">{formatLargo(selectedDate)}</span>
          {isToday && <span className="rec-badge rec-badge--brand">{t("Hoy")}</span>}
        </div>
        <div className="rec-daynav__controls">
          <button className="rec-btn rec-btn--ghost rec-btn--sm" onClick={() => navDay(-1)}>
            <ChevronLeft size={16} />
            {t("Día anterior")}
          </button>
          <button
            className={`rec-btn rec-btn--sm ${isToday ? "rec-btn--outline" : "rec-btn--ghost"}`}
            onClick={() => onSelectedDateChange(todayYmd)}
          >
            {t("Hoy")}
          </button>
          <button className="rec-btn rec-btn--ghost rec-btn--sm" onClick={() => navDay(1)}>
            {t("Día siguiente")}
            <ChevronRight size={16} />
          </button>
          <input
            type="date"
            className="rec-dateinput"
            value={selectedDate}
            onChange={(e) => e.target.value && onSelectedDateChange(e.target.value)}
          />
          {extra}
        </div>
      </div>
    </div>
  );
}
